import type { UbaPatient } from '../queries'

import parsePhoneNumber from 'libphonenumber-js'
import { Link } from 'react-router-dom'

interface UbaUserProps {
  state: UbaPatient
}

export function UbaUser ({ state }: UbaUserProps): JSX.Element {
  const phoneParsed = parsePhoneNumber(state.phone, 'US')

  const delta = new Date().getTime() - new Date(state.dob).getTime()
  const age = Math.abs(new Date(delta).getUTCFullYear() - 1970)

  return (
    <div className='flex flex-row gap-10 p-2 bg-white rounded-lg flex-1'>
      <div className='flex flex-col gap-2 px-6 py-2 pb-4 bg-gray-100 rounded-md max-w-xs'>
        <div className='flex flex-row justify-between'>
          <div
            className='bold patient-name text-base tracking-wide font-bold'
            style={{ fontFamily: 'ProductBold, serif' }}
          >
            {state.patientName}
          </div>
        </div>
        <div><span className='font-bold'>{age}</span> {state.gender} {state.dob}</div>
        <span className='text-zinc-700'>UBACARE ID:</span>
        {state.patientGUID}
      </div>

      <div className='grid grid-cols-[1fr_1fr_min(40px)] gap-4 flex-1 py-4'>
        <div className='flex flex-col gap-2 max-w-[16rem] pl-12'>
          <div className='flex flex-row gap-2 items-start max-w-[16rem]'>
            <span
              className='font-bold'
            >
              {[ state.addressLine1, state.addressLine2, state.cityName, state.stateName, state.zipCode, state.countryName ].filter(Boolean).join(', ')}
            </span>
          </div>
          <span>
            <span className='text-zinc-700'>Phone:</span>
            {' '}{phoneParsed?.formatInternational()}
          </span>
          <span>
            <span className='text-zinc-700'>Email:</span>
            {' '}{state.email}
          </span>
          <span>
            <span className='text-zinc-700'>Member ID:</span>
            {' '}{state.patientId}
          </span>
        </div>

        <div className='flex flex-col gap-2 px-2'>
          {state.currentCondition &&
            <span><span className='text-zinc-700'>Current Condition:</span> {state.currentCondition}</span>
          }
          {state.allergies &&
            <span><span className='text-zinc-700'>Allergies:</span> {state.allergies}</span>
          }
          {state.medicalCondition &&
            <span>
              <span className='text-zinc-700'>Medical Condition:</span>
              {' '}{state.medicalCondition}
            </span>
          }

          {state.patientNotes &&
            <span><span className='text-zinc-700'>Notes:</span> {state.patientNotes}</span>}
        </div>

        <div>
          <Link
            className='text-primary'
            to='edit-user'
          >
            Edit
          </Link>
        </div>
      </div>
    </div>
  )
}
